export const availableColors = [
    "#feea74",
    "#fad672",
    // "#efcb5d",
    "#f99b9b",
    "#ff6262",
    "#fe6f5e",
    "#177245",
    "#00a86b",
    // "#00a550",
    // "#4b92db",
    "#5d8aa8",
    "#6CA2F2",
    "#e5e5e5",
    "#3e3e3e"
]

export const availableGradients = [
    "linear-gradient(326deg, #861657 0%, #ffa69e 74%)",
    "linear-gradient(315deg, #44b09e 0%, #e0d2c7 74%)",
    "linear-gradient(316deg, #cdc1ff 0%, #e5d9f2 74%)",
    "linear-gradient(315deg, #89d4cf 0%, #6e45e1 74%)",
    "linear-gradient(315deg, #e3e3e3 0%, #d93965 74%)",
    `linear-gradient(180deg, #c66f0a 0%, #ff7e05 13%, #fff2d8 33%, #ffe8c5 62%, #228a02 100%) , repeating-conic-gradient( from 0deg, #000080 0deg 5deg, white 5deg 10deg, #000080 10deg 15deg, white 15deg 20deg, #000080 20deg 25deg, white 25deg 30deg, #000080 30deg 35deg, white 35deg 40deg, #000080 40deg 45deg, white 45deg 50deg, #000080 50deg 55deg, white 55deg 60deg, #000080 60deg 65deg, white 65deg 70deg, #000080 70deg 75deg, white 75deg 80deg, #000080 80deg 85deg, white 85deg 90deg`,
    "linear-gradient(to right, #ffe000, #799f0c)",
    "linear-gradient(to right, #00b09b, #96c93d)",
    "linear-gradient(to right, #4e54c8, #8f94fb)",
    "linear-gradient(to right, #1e3c72, #2a5298)"

];
export const availableFonts = [{
    value: '"Poppins",sans-serif',
    label: "Poppins"
},
{ value: " 'Roboto', sans-serif", label: "Roboto" },
{
    value: '"Lato",serif',
    label: "Lato"
},
{ value: " 'Caprasimo', cursive", label: "Caprasimo" },
{ value: " 'Inter', sans-serif", label: "Inter" },
{ value: " 'PT Serif', serif", label: "PT Serif" },

]